import { render, staticRenderFns } from "./ViewScopeOfPracticeCategoryModal.vue?vue&type=template&id=3cd1798b&scoped=true&"
import script from "./ViewScopeOfPracticeCategoryModal.vue?vue&type=script&lang=js&"
export * from "./ViewScopeOfPracticeCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewScopeOfPracticeCategoryModal.vue?vue&type=style&index=0&id=3cd1798b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd1798b",
  null
  
)

export default component.exports